import { gql } from '@apollo/client';

const LAB_FRAGMENT = gql`
  fragment Lab on Lab {
    id
    name
    title
    author
    description
    imageSrc
    enabled
    required
  }
`;

const CONFIGURATION_FILE = gql`
  fragment ConfigurationFile on ConfigFile {
    id
    name
    content
    readOnly
  }
`;

const SCRUBBING_RULE_FRAGMENT = gql`
  fragment ScrubbingRule on ScrubbingRuleRequestBody {
    id
    name
    logFilter
    matchText
    replaceWith
    position
  }
`;

const CORE_ANNOTATION_FIELDS = gql`
  fragment CoreAnnotationFields on Annotation {
    id
    color
    comment
    endMs
    startMs
    labels {
      key
      value
    }
  }
`;

export const Fragments = {
  Lab: LAB_FRAGMENT,
  ConfigurationFile: CONFIGURATION_FILE,
  ScrubbingRule: SCRUBBING_RULE_FRAGMENT,
  Annotation: CORE_ANNOTATION_FIELDS,
};
